module.exports = __webpack_public_path__ + "img/book-reader.ac5ec3cb.svg";